import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuardService } from '../services/authentication/auth-guard.service';
import { RoleGuard } from 'src/services/guard/role-guard.service';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { LoginForgottenPasswordComponent } from './login/login-forgotten-password/login-forgotten-password.component';
import { LoginSignUpComponent } from './login/login-sign-up/login-sign-up.component';
import { ResetPasswordLayoutComponent } from './login/reset-password-layout/reset-password-layout.component';
import { SSOCallbackComponent } from './login/ssocallback/ssocallback.component';

const routes: Routes = [
  { path: '', redirectTo: '/login/sign-up', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    children: [
      { path: 'sign-up', component: LoginSignUpComponent },
      { path: 'forgot-password', component: LoginForgottenPasswordComponent },
      { path: '', redirectTo: 'sign-up', pathMatch: 'full' },
    ],
  },
  { path: 'sso/callback', component: SSOCallbackComponent, pathMatch: 'full' },
  {
    path: 'api/reset-password',
    component: ResetPasswordLayoutComponent,
  },
  {
    path: 'pim',
    component: DashboardComponent,
    canActivate: [AuthGuardService, RoleGuard],
    data: { expectedRoles: ['SUPER_ADMIN', 'ADMIN', 'PIM'] },
    loadChildren: () =>
      import('./dashboard/pim/pim.module').then((p) => p.PimModule),
  },
  {
    path: 'dam',
    component: DashboardComponent,
    canActivate: [AuthGuardService, RoleGuard],
    data: {
      expectedRoles: [
        'SUPER_ADMIN',
        'ADMIN',
        'DAM',
        'MEDIA_MANAGER',
        'GLRY_VIEW',
      ],
    },
    loadChildren: () =>
      import('./dashboard/dam/dam.module').then((d) => d.DamModule),
  },
  {
    path: 'crud-table',
    component: DashboardComponent,
    canActivate: [AuthGuardService, RoleGuard],
    data: { expectedRoles: ['SUPER_ADMIN', 'ADMIN'] },
    loadChildren: () =>
      import('./dashboard/crud-table/crud-table.module').then(
        (c) => c.CrudTableModule
      ),
  },
  {
    path: 'catalogues',
    component: DashboardComponent,
    canActivate: [AuthGuardService, RoleGuard],
    data: { expectedRoles: ['SUPER_ADMIN', 'ADMIN', 'CATALOG'] },
    loadChildren: () =>
      import('./dashboard/catalogues/catalogues.module').then(
        (cs) => cs.CataloguesModule
      ),
  },
  {
    path: 'users',
    component: DashboardComponent,
    canActivate: [AuthGuardService, RoleGuard],
    data: { expectedRoles: ['SUPER_ADMIN'] },
    loadChildren: () =>
      import('./dashboard/users/users.module').then((cs) => cs.UsersModule),
  },
  {
    path: 'gallery',
    loadChildren: () =>
      import('./dashboard/gallery/gallery.module').then(
        (cs) => cs.GalleryModule
      ),
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./shared/shared.module').then((cs) => cs.SharedModule),
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [AuthGuardService],
    loadChildren: () =>
      import('./shared/shared.module').then((cs) => cs.SharedModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
